import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04fc198c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "🤙 Awesome Job 🤙", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ion-padding-top" }, "No more Expenses to review", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_edit_modal = _resolveComponent("edit-modal")!
  const _component_expense_modal = _resolveComponent("expense-modal")!
  const _component_toolbar = _resolveComponent("toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_refresher_content = _resolveComponent("ion-refresher-content")!
  const _component_ion_refresher = _resolveComponent("ion-refresher")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item_divider = _resolveComponent("ion-item-divider")!
  const _component_expense_item = _resolveComponent("expense-item")!
  const _component_ion_item_group = _resolveComponent("ion-item-group")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      (_ctx.editModal && _ctx.user)
        ? (_openBlock(), _createBlock(_component_edit_modal, {
            key: 0,
            isOpen: _ctx.editModal,
            categories: _ctx.categories,
            expense: _ctx.selectedExpense,
            user: _ctx.user,
            onCloseModal: _ctx.handleCloseEditModal
          }, null, 8, ["isOpen", "categories", "expense", "user", "onCloseModal"]))
        : _createCommentVNode("", true),
      _createVNode(_component_expense_modal, {
        isOpen: _ctx.expenseModal,
        expense: _ctx.selectedExpense,
        user: _ctx.user,
        edit: "",
        review: "",
        onApproveReject: _ctx.handleApproveReject,
        onEdit: _cache[0] || (_cache[0] = 
        () => {
          _ctx.expenseModal = false;
          _ctx.editModal = true;
        }
      ),
        onCloseModal: _ctx.handleCloseExpenseModal
      }, null, 8, ["isOpen", "expense", "user", "onApproveReject", "onCloseModal"]),
      _createVNode(_component_ion_header, { class: "ion-no-border" }, {
        default: _withCtx(() => [
          _createVNode(_component_toolbar, { title: "Review" })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, { style: {"margin":"0"} }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, {
                style: {"padding":"0"},
                "size-lg": "6",
                "offset-lg": "3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_refresher, {
                    slot: "fixed",
                    onIonRefresh: _cache[1] || (_cache[1] = ($event: any) => (_ctx.doRefresh($event)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_refresher_content, { pullingIcon: "bubbles" })
                    ]),
                    _: 1
                  }),
                  (_ctx.expenseGroups && _ctx.expenseGroups.length)
                    ? (_openBlock(), _createBlock(_component_ion_list, { key: 0 }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expenseGroups, (group, i) => {
                            return (_openBlock(), _createBlock(_component_ion_item_group, {
                              key: group.date
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_item_divider, {
                                  class: _normalizeClass(i === 0 ? 'no-top-margin' : ''),
                                  color: "primary",
                                  sticky: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(group.date), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["class"]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.expenses, (expense) => {
                                  return (_openBlock(), _createBlock(_component_expense_item, {
                                    key: expense.id,
                                    expense: expense,
                                    showUser: "",
                                    review: "",
                                    onOpenExpenseModal: _ctx.handleOpenExpenseModal
                                  }, null, 8, ["expense", "onOpenExpenseModal"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_ion_card, {
                        key: 1,
                        class: "middle"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_content, null, {
                            default: _withCtx(() => [
                              _hoisted_1,
                              _hoisted_2
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}